import React from "react";
import { Form, FormGroup, FormLabel } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import SubmitControl from "../../core/SubmitControl";
import MessageAlert from "../../core/MessageAlert";
import SubmitButton from "../../core/SubmitButton";
import { Affix } from "antd";

const Login = props => {
  return (
    <div className="Login">
      <Form onSubmit={props.onSubmit}>
        <FormLabel className="Login-Title">DEP SelfCare</FormLabel>
        <FormGroup controlId="username">
          <FormLabel>{labels.username}</FormLabel>
          <SubmitControl
            autoFocus
            placeholder={labels.usernamePlaceholder}
            type="text"
            value={props.username}
            onChange={props.onChange}
          />
        </FormGroup>
        <FormGroup controlId="password">
          <FormLabel>{labels.password}</FormLabel>
          <SubmitControl
            placeholder={labels.passwordPlaceholder}
            type="password"
            value={props.password}
            onChange={props.onChange}
          />
        </FormGroup>
        <Affix>
          <div>
            <SubmitButton
              className=""
              text={labels.login}
              disabled={!props.isValid()}
              block
            />
          </div>
        </Affix>
      </Form>

      {/* <div
      className="d-flex justify-content-center"
      onSubmit={props.onRegisterSubmit}
    >
      <div className="Register">
        <FormLabel>{labels.needAccount}</FormLabel>
        <Button variant="link" onClick={props.onRegisterClick}>
          {labels.register}
        </Button>
      </div>
    </div> */}

      <MessageAlert ref={props.alertRef} className="LoginAlert" />
    </div>
  );
};

export default Login;
